import clsx from 'clsx'
import compact from 'lodash/compact'
import React, { FC } from 'react'

import { NativeModal, NativeModalBody, NativeModalHeader, useNativeModalActions } from '@Components/Modal/NativeModal/NativeModal'
import { Button } from '@CoreComponents/Buttons/Button'
import { useSplitTest } from '@Globals/SplitTests/Hooks'
import { useTranslation } from '@Globals/Translations'

import styles from './DeliveryInfoDialog.module.scss'

export interface DeliveryInfoDialogProps {
  info?: string | null
  onClose: () => void
}

export const DeliveryInfoDialog: FC<DeliveryInfoDialogProps> = ({
  info,
  onClose,
}) => {
  const cofDesignV1 = useSplitTest('cof_design_v1', 'b')
  const ref = useNativeModalActions()
  const { t } = useTranslation()

  if (!info) {
    return null
  }
  const items = info.split('\n')
  return (
    <NativeModal actionRef={ref} backdrop closeOnBackDrop closeOnEscape defaultOpen onClose={onClose}>
      <NativeModalHeader />
      <NativeModalBody>
        <div className={clsx(styles.deliveryInfoDialog, cofDesignV1 && styles.cofDesignV1)}>
          <p>{items[0]}</p>
          <ul>
            {compact(items.slice(1))
              .map(item => (
                <li key={`${item}}`}>{item}</li>
              ))}
          </ul>
          <Button
            className={clsx(cofDesignV1 ? styles.buttonWrapper : styles.closeButton)}
            fillWidth={cofDesignV1}
            innerSpacing="medium"
            onClick={() => {
              onClose()
              ref.current?.close()
            }}
            theme={cofDesignV1 ? 'black' : 'white'}
          >
            {t('common:CLOSE')}
          </Button>
        </div>
      </NativeModalBody>
    </NativeModal>
  )
}

